import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { IoClose } from "react-icons/io5";

const AddFaqModal = ({ show, handleClose }) => {
  const styles = {
    header: {
      borderBottom: "1px solid #e5e7eb",
      padding: "16px 20px",
      fontWeight: 600,
      fontSize: "20px",
      color: "#1f2937",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    closeBtn: {
      background: "#6b7280",
      borderRadius: "50%",
      width: "28px",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      cursor: "pointer",
    },
    body: {
      padding: "20px",
    },
    label: {
      fontSize: "14px",
      marginBottom: "6px",
      color: "#374151",
      fontWeight: 500,
    },
    input: {
      height: "42px",
      borderRadius: "6px",
      border: "1px solid #e5e7eb",
      fontSize: "14px",
    },
    textarea: {
      borderRadius: "6px",
      border: "1px solid #e5e7eb",
      fontSize: "14px",
    },
    footer: {
      borderTop: "1px solid #e5e7eb",
      padding: "14px 20px",
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
    },
    cancelBtn: {
      background: "#f3f4f6",
      border: "1px solid #e5e7eb",
      color: "#111827",
      padding: "6px 14px",
      borderRadius: "6px",
      fontSize: "14px",
    },
    addBtn: {
      background: "#f97316",
      border: "none",
      color: "#fff",
      padding: "6px 16px",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: 500,
    },
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      
      {/* HEADER */}
      <div style={styles.header}>
        Add Faq
        <div style={styles.closeBtn} onClick={handleClose}>
          <IoClose size={16} />
        </div>
      </div>

      {/* BODY */}
      <div style={styles.body}>
        <Form>
          
          {/* Category */}
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label style={styles.label}>Category</Form.Label>
            <Form.Control type="text" style={styles.input} />
          </Form.Group>

          {/* Questions */}
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label style={styles.label}>Questions</Form.Label>
            <Form.Control type="text" style={styles.input} />
          </Form.Group>

          {/* Answer */}
          <Form.Group>
            <Form.Label style={styles.label}>Answer</Form.Label>
            <Form.Control as="textarea" rows={4} style={styles.textarea} />
          </Form.Group>

        </Form>
      </div>

      {/* FOOTER */}
      <div style={styles.footer}>
        <Button style={styles.cancelBtn} onClick={handleClose}>
          Cancel
        </Button>
        <Button style={styles.addBtn}>
          Add Faq
        </Button>
      </div>

    </Modal>
  );
};

export default AddFaqModal;